import {
  type PimCautionV1,
  type PimProductV11,
} from '@redteclab/api/clients/bully'

import { TENANT } from '../../../tenant'

import { productAccessorIsPrescriptionProduct } from './productAccessorIsPrescriptionProduct'

export const productAccessorGetCautions = (
  product: PimProductV11,
  tenant: TENANT,
): PimCautionV1[] => {
  const isPrescriptionProduct = productAccessorIsPrescriptionProduct(product)

  if (![TENANT.COM].includes(tenant) || !isPrescriptionProduct) {
    return []
  }

  const { cautions } = product

  if (!cautions || cautions.length === 0) {
    return []
  }
  const overwrittenCautions = new Set(
    cautions.flatMap((caution) => caution.overwrites_cautions ?? []),
  )

  /**
   * filter out cautions with no pictogram_url or laymen_text
   * filter out cautions overwritten by another caution. For more details check (WSAWA-5812, WSAWA-6144)
   */
  return cautions.filter(
    (caution) =>
      caution.pictogram_url &&
      caution.laymen_text &&
      !overwrittenCautions.has(caution.code),
  )
}
